module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("BL - US")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard'), _vm._v(" "), (_vm.BLRaised.fclBlId != '' && _vm.BLRaised.fclBlId != undefined && _vm.originalDone == true) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.openPopBLMail
    }
  }, [_vm._v("Edit BL Request")]) : _vm._e(), _vm._v(" "), (
    _vm.BLRaised.fclBlId != '' &&
    (this.$sessionsStorage.get('designation') == 'Admin' ||
      this.$sessionsStorage.get('userId') == '110') && _vm.originalDone == true
  ) ? _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.openNoteModal(2)
      }
    }
  }, [_vm._v("Debit Note")]) : _vm._e(), _vm._v(" "), (
    _vm.BLRaised.fclBlId != '' &&
    (this.$sessionsStorage.get('designation') == 'Admin' ||
      this.$sessionsStorage.get('userId') == '110') && _vm.originalDone == true
  ) ? _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.openNoteModal(1)
      }
    }
  }, [_vm._v("Credit Note")]) : _vm._e(), _vm._v(" "), (_vm.BLRaised.fclBlId != '') ? _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.openPreAlert
    }
  }, [_vm._v("Send Pre-Alert Mail")]) : _vm._e(), _vm._v(" "), (_vm.selectedConFclBLNonUsId != '') ? _c('b-button', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "variant": "warning",
      "size": "sm",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.proceedToTally
    }
  }, [_vm._v("Proceed To Invoice")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.getCLientData.length > 0 || _vm.BLRaised.conFclBLNonUsId != '') ? _c('div', [(_vm.containerDetail.length > 0) ? _c('div', {
    staticClass: "box mt-4"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "box-title"
  }, [_vm._v("Container Detail(US)")])]), _vm._v(" "), (_vm.allModuleId) ? _c('UpdateContainerWithClient', {
    ref: "childComponent",
    attrs: {
      "showContainerClient": _vm.showContainerClient,
      "allModuleId": Number(_vm.allModuleId),
      "JobNo": _vm.BLRaised.ffExportFclConsoSeries,
      "ClientId": Number(_vm.BLRaised.clientId),
      "MultiClientId": Number(_vm.BLRaised.fclConsoMultipleClientId),
      "ffFclConsoExportId": Number(_vm.BLRaised.ffFclConsoExportId)
    },
    on: {
      "update": _vm.refreshData,
      "selection-change": _vm.onContainerSelectionChange
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [(_vm.BLRaised.conFclBLNonUsId == '') ? _c('label', {
    attrs: {
      "for": "fclConsoMultipleClientId"
    }
  }, [_vm._v("Client Name")]) : _vm._e(), _vm._v(" "), (_vm.BLRaised.conFclBLNonUsId == '') ? _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "fclConsoMultipleClientId",
      "option-value": "fclConsoMultipleClientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.BLRaised.fclConsoMultipleClientId),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "fclConsoMultipleClientId", $$v)
      },
      expression: "BLRaised.fclConsoMultipleClientId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientName"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.BLRaised.clientName),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "clientName", $$v)
      },
      expression: "BLRaised.clientName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("B/L Stage")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.originalDone == false ? _vm.blStageList : _vm.blStageListAfterOriginalCreated,
      "option-value": "blStageVal",
      "option-text": "blStageTxt",
      "placeholder": "Select B/L Stage"
    },
    on: {
      "input": _vm.checBlstage
    },
    model: {
      value: (_vm.BLRaised.blStage),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "blStage", $$v)
      },
      expression: "BLRaised.blStage"
    }
  }), _vm._v(" "), (!_vm.BLRaised.blStage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.blStage) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("B\\L Created on")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('date-picker', {
    attrs: {
      "width": "100%",
      "lang": "en",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm ",
      "minute-step": 1,
      "id": "acceptanceDate"
    },
    model: {
      value: (_vm.BLRaised.blDate),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "blDate", $$v)
      },
      expression: "BLRaised.blDate"
    }
  }), _vm._v(" "), (!_vm.BLRaised.blDate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.errorBLRaised.blDate) + "\n                  ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("EXPORTER / SHIPPER")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("CONSIGNEE ( OR ORDER)")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "consignor",
    attrs: {
      "width": "700px !important;",
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.consignor),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "consignor", $$v)
      },
      expression: "BLRaised.consignor"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.consignor) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.consignor) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "width": "100%",
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.consignee),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "consignee", $$v)
      },
      expression: "BLRaised.consignee"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.consignee) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.consignee) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "gutter": ""
    }
  }, [_vm._l((_vm.BLRaised.notifyList), function(singleInput, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "30"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      staticClass: "pl-2 pr-2",
      attrs: {
        "md-flex": "60"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.notifyArray[index]) + " Notify Party")])]), _vm._v(" "), (index > 1) ? _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      staticStyle: {
        "min-height": "20px",
        "height": "20px"
      },
      on: {
        "click": function($event) {
          _vm.removeNotify(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      staticClass: "pl-2 pr-2",
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', [_c('quill-editor', {
      ref: "myTextEditor",
      refInFor: true,
      model: {
        value: (singleInput.inputValue),
        callback: function($$v) {
          _vm.$set(singleInput, "inputValue", $$v)
        },
        expression: "singleInput.inputValue"
      }
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  })], 2), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    staticClass: "showMoreData",
    on: {
      "click": _vm.addNotify
    }
  }, [_vm._v("Add Notify")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "60"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Bill of Lading No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "billLading",
      "name": "billLading"
    },
    model: {
      value: (_vm.BLRaised.billLading),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "billLading", $$v)
      },
      expression: "BLRaised.billLading"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.billLading) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.billLading) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Booking No.")]), _vm._v(" "), _c('b-form-input', {
    ref: "bookingNo",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "bookingNo",
      "name": "bookingNo"
    },
    model: {
      value: (_vm.BLRaised.bookingNo),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "bookingNo", $$v)
      },
      expression: "BLRaised.bookingNo"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.bookingNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.bookingNo) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Consolidation No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidationNO",
      "name": "consolidationNO"
    },
    model: {
      value: (_vm.BLRaised.consolidationNO),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "consolidationNO", $$v)
      },
      expression: "BLRaised.consolidationNO"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.consolidationNO) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.consolidationNO) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("SCAC")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "SCAC",
      "name": "SCAC"
    },
    model: {
      value: (_vm.BLRaised.SCAC),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "SCAC", $$v)
      },
      expression: "BLRaised.SCAC"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.SCAC) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.SCAC) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Type of Move")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "typeMove",
      "name": "typeMove"
    },
    model: {
      value: (_vm.BLRaised.typeMove),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "typeMove", $$v)
      },
      expression: "BLRaised.typeMove"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.typeMove) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.typeMove) + "\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Export References")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "exportReference",
      "name": "exportReference"
    },
    model: {
      value: (_vm.BLRaised.exportReference),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "exportReference", $$v)
      },
      expression: "BLRaised.exportReference"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.exportReference) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.exportReference) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper References")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingReferenceNum",
      "name": "shippingReferenceNum"
    },
    model: {
      value: (_vm.BLRaised.shippingReferenceNum),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "shippingReferenceNum", $$v)
      },
      expression: "BLRaised.shippingReferenceNum"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.shippingReferenceNum) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.shippingReferenceNum) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Forwarding Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.AgentList,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Delievery Agent"
    },
    on: {
      "input": _vm.getForwardAgentName
    },
    model: {
      value: (_vm.BLRaised.forwardingAgent),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "forwardingAgent", $$v)
      },
      expression: "BLRaised.forwardingAgent"
    }
  }), _vm._v(" "), (!_vm.BLRaised.forwardingAgent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.forwardingAgent) + "\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Pre­Carriage By")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "",
      "name": ""
    },
    model: {
      value: (_vm.BLRaised.preCarriage),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "preCarriage", $$v)
      },
      expression: "BLRaised.preCarriage"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.preCarriage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.preCarriage) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Delievery Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.AgentList,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Delievery Agent"
    },
    on: {
      "input": _vm.getAgentName
    },
    model: {
      value: (_vm.BLRaised.delieveryAgent),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "delieveryAgent", $$v)
      },
      expression: "BLRaised.delieveryAgent"
    }
  }), _vm._v(" "), (!_vm.BLRaised.delieveryAgent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.delieveryAgent) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Point of Origin/FTZ No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "pointofOrigin",
      "name": "pointofOrigin"
    },
    model: {
      value: (_vm.BLRaised.pointofOrigin),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "pointofOrigin", $$v)
      },
      expression: "BLRaised.pointofOrigin"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.pointofOrigin) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.pointofOrigin) + "\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place of Receipt By Pre-Carrier")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "placeReceipt",
      "name": "placeReceipt"
    },
    model: {
      value: (_vm.BLRaised.placeReceipt),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "placeReceipt", $$v)
      },
      expression: "BLRaised.placeReceipt"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.placeReceipt) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.placeReceipt) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Loading Peer / Terminal")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "loadingPreTerminal",
      "name": "loadingPreTerminal"
    },
    model: {
      value: (_vm.BLRaised.loadingPreTerminal),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "loadingPreTerminal", $$v)
      },
      expression: "BLRaised.loadingPreTerminal"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.loadingPreTerminal) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.loadingPreTerminal) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel/Voy")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vesselVoy",
      "name": "vesselVoy"
    },
    model: {
      value: (_vm.BLRaised.vesselVoy),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "vesselVoy", $$v)
      },
      expression: "BLRaised.vesselVoy"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.vesselVoy) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.vesselVoy) + "\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port of Loading")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "portLoad",
      "name": "portLoad"
    },
    model: {
      value: (_vm.BLRaised.portLoad),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "portLoad", $$v)
      },
      expression: "BLRaised.portLoad"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.portLoad) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.portLoad) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "portDischarge",
      "name": "portDischarge"
    },
    model: {
      value: (_vm.BLRaised.portDischarge),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "portDischarge", $$v)
      },
      expression: "BLRaised.portDischarge"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.portDischarge) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.portDischarge) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place of Delivery")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "placeDilievery",
      "name": "placeDilievery"
    },
    model: {
      value: (_vm.BLRaised.placeDilievery),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "placeDilievery", $$v)
      },
      expression: "BLRaised.placeDilievery"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.placeDilievery) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.placeDilievery) + "\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Refrences")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "reference",
      "name": "reference"
    },
    model: {
      value: (_vm.BLRaised.reference),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "reference", $$v)
      },
      expression: "BLRaised.reference"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.reference) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.reference) + "\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "80"
    }
  }, [_c('label', [_vm._v("Description of Packages and Goods")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "10"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "60"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "900px !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.descriptionGood),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "descriptionGood", $$v)
      },
      expression: "BLRaised.descriptionGood"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.descriptionGood) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.descriptionGood) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Description of Charges")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Prepaid")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Collect")])])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.desCharges),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "desCharges", $$v)
      },
      expression: "BLRaised.desCharges"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.BLRaised.desCharges) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.desCharges) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.prepaid),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "prepaid", $$v)
      },
      expression: "BLRaised.prepaid"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.prepaid) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.prepaid) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.collect),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "collect", $$v)
      },
      expression: "BLRaised.collect"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.collect) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.collect) + "\n                ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Place")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PlaceListNew,
      "option-value": "pickupLocation",
      "option-text": "pickupLocation",
      "placeholder": "Select Pridel Branch Name"
    },
    model: {
      value: (_vm.BLRaised.placeBranch),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "placeBranch", $$v)
      },
      expression: "BLRaised.placeBranch"
    }
  }), _vm._v(" "), (!_vm.BLRaised.placeBranch) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.placeBranch) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Total")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "total",
      "name": "total"
    },
    model: {
      value: (_vm.BLRaised.total),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "total", $$v)
      },
      expression: "BLRaised.total"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.total) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                  " + _vm._s(_vm.errorBLRaised.total) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.savegenerateblprealertStatus == true ? true : false,
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addBLRaised
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  })], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.BLRaised.CreatedBY) ? _c('h5', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Created/Updated = " + _vm._s(" " + _vm.BLRaised.CreatedBY + " -- " + _vm.BLRaised.createUpdate))])]) : _vm._e(), _vm._v(" "), (_vm.nonUsBlTable.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Client BL Details(US)")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "clientSB"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("BL Stage")]), _vm._v(" "), _c('th', [_vm._v("Print")]), _vm._v(" "), _c('th', [_vm._v("Download Word")]), _vm._v(" "), _c('th', [_vm._v("Proceed To Invoice")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.nonUsBlTable), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEditBLNonUs(item)
        }
      }
    }, [_vm._v(_vm._s(item.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.blStage)), _c('br'), _vm._v(" "), (item.billLading) ? _c('b', [_vm._v(_vm._s(item.billLading))]) : _vm._e(), _c('br'), _vm._v(" "), (item.CreatedBY) ? _c('span', [_vm._v("Created By : " + _vm._s(item.CreatedBY)), _c('br')]) : _vm._e(), _vm._v(" "), (item.CreatedDate) ? _c('span', [_vm._v("Created At : " + _vm._s(item.CreatedDate)), _c('br')]) : _vm._e(), _vm._v(" "), (item.UpdatedBY) ? _c('span', [_vm._v("Updated By : " + _vm._s(item.UpdatedBY)), _c('br')]) : _vm._e(), _vm._v(" "), (item.UpdatedDate) ? _c('span', [_vm._v("Updated At : " + _vm._s(item.UpdatedDate)), _c('br')]) : _vm._e()]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.Print(item.uploadBLCon)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1)], 1), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.downloadWord(item.conFclBLNonUsId)
        }
      }
    }, [_c('md-icon', [_vm._v("cloud_download")])], 1)], 1), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.proceedToTallyByClient(
            item.conFclBLNonUsId,
            item.InvTallyId,
            item.clientName
          )
        }
      }
    }, [_vm._v("\n                        Invoice\n                      ")])], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.BLRaised.conFclBLNonUsId == '' && _vm.getCLientData.length == 0) ? _c('hr', {
    staticClass: "hr-s"
  }) : _vm._e(), _vm._v(" "), (_vm.getCLientData.length == 0 && _vm.BLRaised.conFclBLNonUsId == '') ? _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.proceedAws
    }
  }, [_vm._v("Proceed to AMS Filling")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "note-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.noteModal.creditDebitNoteType == '1' ? 'CREDIT NOTE' : 'DEBIT NOTE'
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h4', {
    staticClass: "error"
  }, [_vm._v("\n        " + _vm._s(_vm.noteModal.approvalStatus == "1" ?
    "Approved" :
    _vm.noteModal.sentForApproval == "1" ?
    "Sent for approval" :
    "") + "\n      ")])]), _vm._v(" "), (
    _vm.noteModal.uploadCreditDebit != '' && _vm.noteModal.approvalStatus == '1'
  ) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.PrintNote(_vm.noteModal.uploadCreditDebit)
      }
    }
  }, [_vm._v("PDF")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("\n      Add Particulars\n      "), _c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('md-layout', {
    staticStyle: {
      "width": "400px"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.AgentColoaderList,
      "option-value": "agentName",
      "option-text": "agentName",
      "placeholder": "Select Agent/Client"
    },
    model: {
      value: (_vm.noteModal.AgentColoader),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "AgentColoader", $$v)
      },
      expression: "noteModal.AgentColoader"
    }
  }), _vm._v(" "), (!_vm.noteModal.AgentColoader) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCDNote.AgentColoader))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.noteParticulars), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-4"
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "cols": "8"
      }
    }, [_c('label', {
      attrs: {
        "for": "jj"
      }
    }, [_vm._v("Particular")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "Enter Particular"
      },
      model: {
        value: (item.parti),
        callback: function($$v) {
          _vm.$set(item, "parti", $$v)
        },
        expression: "item.parti"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('label', {
      attrs: {
        "for": "jju"
      }
    }, [_vm._v("Amount")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Amount"
      },
      model: {
        value: (item.amt),
        callback: function($$v) {
          _vm.$set(item, "amt", $$v)
        },
        expression: "item.amt"
      }
    })], 1), _vm._v(" "), (index > 0) ? _c('b-button', {
      staticClass: "pull-right",
      staticStyle: {
        "margin-top": "38px"
      },
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeParti(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.noteModal.remarks),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "remarks", $$v)
      },
      expression: "noteModal.remarks"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.noteParticulars.length > 0 &&
    _vm.ShowSendApproval == true &&
    _vm.noteModal.approvalStatus != '1'
  ) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "success",
      "block": ""
    },
    on: {
      "click": _vm.submitNote
    }
  }, [_vm._v("Send for approval")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-5",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideNoteModal
    }
  }, [_vm._v("Close")])], 2), _vm._v(" "), _c('b-modal', {
    ref: "pre-alert-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "FCL Export BL Pre Alert"
    }
  }, [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [(_vm.preAlertData.fclConAlertId != '' && _vm.allData[0].billingType != '1') ? _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.sendMANIFESTATION
    }
  }, [_vm._v("SEND MANIFESTATION DETAILS")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("AGENT REFERENCE ID")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "VESSEL & VOY"
    },
    model: {
      value: (_vm.preAlertData.agent_reference_id),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "agent_reference_id", $$v)
      },
      expression: "preAlertData.agent_reference_id"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("SHIPPING LINE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "SHIPPING LINE"
    },
    model: {
      value: (_vm.preAlertData.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "shippingLine", $$v)
      },
      expression: "preAlertData.shippingLine"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("SHIPMENT TYPE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "SHIPMENT TYPE"
    },
    model: {
      value: (_vm.preAlertData.shipmentType),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "shipmentType", $$v)
      },
      expression: "preAlertData.shipmentType"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("SHIPPER NAME")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "SHIPPER NAME"
    },
    model: {
      value: (_vm.preAlertData.shipper_name),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "shipper_name", $$v)
      },
      expression: "preAlertData.shipper_name"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("LOAD PORT")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "LOAD PORT"
    },
    model: {
      value: (_vm.preAlertData.portLoad),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "portLoad", $$v)
      },
      expression: "preAlertData.portLoad"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("PLACE OF DELIVERY")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "PLACE OF DELIVERY"
    },
    model: {
      value: (_vm.preAlertData.placeDilievery),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "placeDilievery", $$v)
      },
      expression: "preAlertData.placeDilievery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("CONTAINER NO.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "CONTAINER NO."
    },
    model: {
      value: (_vm.preAlertData.container_no),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "container_no", $$v)
      },
      expression: "preAlertData.container_no"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("HOUSE BL NO.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "HOUSE BL NO."
    },
    model: {
      value: (_vm.preAlertData.house_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "house_bl_no", $$v)
      },
      expression: "preAlertData.house_bl_no"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("MASTER BL NO.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "MASTER BL NO."
    },
    model: {
      value: (_vm.preAlertData.master_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "master_bl_no", $$v)
      },
      expression: "preAlertData.master_bl_no"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("VESSEL & VOY")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "VESSEL & VOY"
    },
    model: {
      value: (_vm.preAlertData.vesselVoy),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "vesselVoy", $$v)
      },
      expression: "preAlertData.vesselVoy"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("ETD / SOB DATE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "ETD / SOB DATE"
    },
    model: {
      value: (_vm.preAlertData.etd_date),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "etd_date", $$v)
      },
      expression: "preAlertData.etd_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("ETA DISCHARGE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "ETA DISCHARGE"
    },
    model: {
      value: (_vm.preAlertData.eta_date),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "eta_date", $$v)
      },
      expression: "preAlertData.eta_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsName,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.preAlertData.deliverytermmode),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "deliverytermmode", $$v)
      },
      expression: "preAlertData.deliverytermmode"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.deliverytermmode))])], 1), _vm._v(" "), (_vm.preAlertData.deliverytermmode == 'ExWorks' || _vm.preAlertData.deliverytermmode == 'DAP' || _vm.preAlertData.deliverytermmode == 'DDP' || _vm.preAlertData.deliverytermmode == 'FCA' || _vm.preAlertData.deliverytermmode == 'FOB' || _vm.preAlertData.deliverytermmode == 'CIF' || _vm.preAlertData.deliverytermmode == 'CFR') ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Handling Agent"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllAgentDDList'],
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Handling Agent"
    },
    on: {
      "input": function($event) {
        _vm.getAgentDeatils(_vm.preAlertData.handling_agent, 'handling_agent')
      }
    },
    model: {
      value: (_vm.preAlertData.handling_agent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "handling_agent", $$v)
      },
      expression: "preAlertData.handling_agent"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.handling_agent))])], 1) : _vm._e(), _vm._v(" "), (_vm.preAlertData.deliverytermmode == 'ExWorks' || _vm.preAlertData.deliverytermmode == 'DAP' || _vm.preAlertData.deliverytermmode == 'DDP' || _vm.preAlertData.deliverytermmode == 'FCA') ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Clearing Agent"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllAgentDDList'],
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Clearing Agent"
    },
    on: {
      "input": function($event) {
        _vm.getAgentDeatils(_vm.preAlertData.clearing_agent, 'clearing_agent')
      }
    },
    model: {
      value: (_vm.preAlertData.clearing_agent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "clearing_agent", $$v)
      },
      expression: "preAlertData.clearing_agent"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.clearing_agent))])], 1) : _vm._e(), _vm._v(" "), (_vm.preAlertData.deliverytermmode == 'ExWorks' || _vm.preAlertData.deliverytermmode == 'DAP' || _vm.preAlertData.deliverytermmode == 'DDP' || _vm.preAlertData.deliverytermmode == 'FCA') ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Delivery Agent"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.invCategoryList,
      "option-value": "payVal",
      "option-text": "payText",
      "placeholder": "Select Delivery Agent"
    },
    on: {
      "input": function($event) {
        _vm.getAgentDeatils(_vm.preAlertData.delivery_agent, 'delivery_agent')
      }
    },
    model: {
      value: (_vm.preAlertData.delivery_agent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "delivery_agent", $$v)
      },
      expression: "preAlertData.delivery_agent"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.delivery_agent))])], 1) : _vm._e(), _vm._v(" "), (_vm.preAlertData.delivery_agent == 'Agent') ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllAgentDDList'],
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Agent"
    },
    on: {
      "input": function($event) {
        _vm.getAgentDeatils(_vm.preAlertData.agent_type_agent, 'agent_type_agent')
      }
    },
    model: {
      value: (_vm.preAlertData.agent_type_agent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "agent_type_agent", $$v)
      },
      expression: "preAlertData.agent_type_agent"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.agent_type_agent))])], 1) : _vm._e(), _vm._v(" "), (_vm.preAlertData.delivery_agent == 'Shipping Line') ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Shipping Line"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getAgentDeatils(_vm.preAlertData.agent_type_sline, 'agent_type_sline')
      }
    },
    model: {
      value: (_vm.preAlertData.agent_type_sline),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "agent_type_sline", $$v)
      },
      expression: "preAlertData.agent_type_sline"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.agent_type_sline))])], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "frghtTermsHbl"
    }
  }, [_vm._v("Shipping Line Charges"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.frghtTermsHblListName,
      "option-value": "frghtTermsHblVal",
      "option-text": "frghtTermsHblTxt",
      "placeholder": "Select Shipping Line Charges"
    },
    model: {
      value: (_vm.preAlertData.sline_charges),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "sline_charges", $$v)
      },
      expression: "preAlertData.sline_charges"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.sline_charges))])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("CONSIGNEE")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.preAlertData.consignee),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "consignee", $$v)
      },
      expression: "preAlertData.consignee"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("OVERSEAS AGENT")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.preAlertData.delieveryAgent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "delieveryAgent", $$v)
      },
      expression: "preAlertData.delieveryAgent"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Master BL")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "placeholder": "Click to Upload Master BL",
      "name": "masterUpload",
      "id": "masterUpload",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChangeBlDraft('masterBl')
      }
    },
    model: {
      value: (_vm.preAlertData.masterBlUpload),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "masterBlUpload", $$v)
      },
      expression: "preAlertData.masterBlUpload"
    }
  })], 1), _vm._v(" "), (_vm.preAlertData.masterBlUpload != '' && _vm.preAlertData.masterBlUpload != undefined && _vm.preAlertData.masterBlUpload != null) ? _c('b', _vm._l((_vm.preAlertData.masterBlUpload.split(',')), function(item_MB_doc, index_MB_doc) {
    return _c('span', {
      key: index_MB_doc
    }, [(item_MB_doc != '') ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.Print(item_MB_doc)
        }
      }
    }, [_vm._v("View Document - " + _vm._s(index_MB_doc + 1))]) : _vm._e(), _vm._v(" "), _c('br')])
  })) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload House BL")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "placeholder": "Click to Upload House Bl",
      "name": "houseUpload",
      "id": "houseUpload",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChangeBlDraft('houseBl')
      }
    },
    model: {
      value: (_vm.preAlertData.houseBlUpload),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "houseBlUpload", $$v)
      },
      expression: "preAlertData.houseBlUpload"
    }
  })], 1), _vm._v(" "), (_vm.preAlertData.houseBlUpload != '' && _vm.preAlertData.houseBlUpload != undefined && _vm.preAlertData.houseBlUpload != null) ? _c('b', _vm._l((_vm.preAlertData.houseBlUpload.split(',')), function(item_HB_doc, index_HB_doc) {
    return _c('span', {
      key: index_HB_doc
    }, [(item_HB_doc != '') ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.Print(item_HB_doc)
        }
      }
    }, [_vm._v("View Document - " + _vm._s(index_HB_doc + 1))]) : _vm._e(), _vm._v(" "), _c('br')])
  })) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": (_vm.preAlertData.condition)
    },
    on: {
      "click": _vm.submitPreAlert
    }
  }, [_vm._v("Send Pre Alert request")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hidePreAlert
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popBlStageMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.openPreAlert
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popBLMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendBLApprovalMail
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20bbf6b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ffExportCon/conBLNewSlineUs.vue
// module id = 2448
// module chunks = 0